import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { GlobalErrorHandler } from "../handlers/global-error-handler";
import { catchError, throwError } from "rxjs";
import { UserInfoStore } from "@shared/core/auth";

export const errorInterceptor:HttpInterceptorFn=(req,next)=>{
    const errorHandler=inject(GlobalErrorHandler);
    const userInfoStore=inject(UserInfoStore);

    return next(req).pipe(
        catchError((error:HttpErrorResponse)=>{
            if(error.status==401){
                // redirect to login
                userInfoStore.logOut(); 

            }
            // errorHandler.handleError(error);
            return throwError(()=> error);
        })
    );
}